import Class from '@/Class';
import type SummaryViewFactory from '@/Factories/SummaryViewFactory';

export default class SummaryViewFactoryTuple extends Class {

    public view: JQuery<HTMLElement>;
    public factory: SummaryViewFactory;

    constructor(factory: SummaryViewFactory, $view: JQuery) {
        super();

        this.view = $view;
        this.factory = factory;
        this.isDisposable = true;
    }
}